import React from "react";

function ITcareerContent () {
    return(
        <section className="skill-section bg-grey padding">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6">
                        <div className="video-wrap">
                            <img src="assets/img/post-15.jpg" alt="img" />
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="section-heading mb-30">
                            <h2 className="text-anim" data-effect="fade-in-right" data-split="char" data-delay="0.3" data-duration={1}> IT Career Counseling  </h2>
                            <p className="text-anim" data-effect="fade-in-bottom" data-ease="power4.out">
                            Our career counseling services are designed to empower IT professionals:
                            </p>
                            <ul className="text-anim" data-effect="fade-in-bottom" data-ease="power4.out" style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
                                <li> Personalized Guidance: Understanding individual skills and aspirations. </li>
                                <li>Skill Assessments: Identifying strengths and areas of improvement.</li>
                                <li>Career Path Planning: Mapping out long-term career goals.</li>
                                <li>Job Market Insights: Providing trends and opportunities in the IT industry.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ITcareerContent;